import { cn } from "tailwind-variants";
import StickersToolsColorPicker from "./StickersToolsColorPicker.vue";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import "../../types";
import { useDtfStore } from "../../store";
import { useStickersStore } from "../../stickers-module";
import "./StickersToolsBackground.scss";

function StickersToolsBackground({ artwork, ...restProps }) {
  const store = useDtfStore();
  const stickersStore = useStickersStore();

  function selectedBgColor() {
    return artwork.bgColor;
  }

  function handleChange(bgColor) {
    store.updateArtworkValuesById({
      id: artwork.id,
      bgColor
    });
    const payload = {
      background_color: bgColor,
      page: "PDP",
      business_line: "Stickers",
      artwork_id: artwork.id,
      is_bg_removed: artwork.removeBackground
    };
    submitDtfEvent("user_applied_background_color_to_sticker", payload);
    if (!artwork.isFile && !artwork.isSimulated) {
      stickersStore.generateStickerImage({
        artwork,
        bgColor
      });
    }
  }

  return (
    <div {...restProps} className={cn("stickers-tools-background", restProps.className)}>
      <h3 className="stickers-tools-background__title">Select Background Color</h3>
      <StickersToolsColorPicker
        value={selectedBgColor()}
        onChange={handleChange}
        data-testid="stickers-tools-color-picker"
      />
    </div>
  );
}

export default StickersToolsBackground;
